import { contrastRatio, darken, normalizeHex, onBrandText, tint } from "../../utils/color";

/** EasyPlanner's own green: what a page without a valid colour falls back to. */
export const DEFAULT_PRIMARY = "#5c9f24";

const INK = "#1a1d19";
const WHITE = "#ffffff";

/**
 * The darkest step of `hex` that still reads as the same colour, but carries
 * small text on white at WCAG AA (4.5:1). A business that picks a pale brand
 * colour keeps it on buttons and surfaces; its links and eyebrows get this.
 */
const textSafe = (hex) => {
  let value = hex;
  for (let step = 0; step < 12 && contrastRatio(value, WHITE) < 4.5; step += 1) {
    value = darken(value, 0.1);
  }
  return value;
};

/**
 * The business's two colours as the `--site1-*` custom properties every Site1
 * section reads through arbitrary values (`bg-[var(--site1-primary)]`).
 *
 * Only validated hex reaches the style attribute: these values come from
 * stored settings, and an unchecked string in a custom property can close the
 * declaration and add its own. The secondary colour is used for headings, and
 * only when it is dark enough to read on white — a heading nobody can read is
 * not a branding choice anyone made on purpose.
 */
export const siteThemeStyle = (colors = {}) => {
  const primary = normalizeHex(colors.primary) || DEFAULT_PRIMARY;
  const secondary = normalizeHex(colors.secondary);

  return {
    "--site1-primary": primary,
    "--site1-primary-hover": darken(primary, 0.12),
    "--site1-on-primary": onBrandText(primary, INK),
    "--site1-primary-strong": textSafe(primary),
    "--site1-primary-soft": tint(primary, 0.07),
    "--site1-primary-muted": tint(primary, 0.16),
    "--site1-heading":
      secondary && contrastRatio(secondary, WHITE) >= 4.5 ? secondary : INK,
  };
};
